module.exports = __webpack_public_path__ + "img/logo_yostar.67059cbd.png";